<div class="info-help-message">
    <div class="info-help-message-header">{{ messages.header }}</div>
    <div class="info-help-message-container" [innerHTML]="messages.infoText"></div>
    <div class="info-help-close-button" (click)="closeClick()">{{ messages.closeText }}</div>
</div>
